###
Keeps an element's size in sync with its parent gridster-item.
###
angular.module('rjmNg.directives').directive 'gridsterItemSize', [
  "$window"
  "$timeout"
  "utils"
  (
    $window
    $timeout
    utils
  ) ->
    restrict: "A"
    replace: false
    priority: 100
    require: [
      "^gridsterItem"
    ]
    link: (scope, elem, attrs, controllers) ->
      gridsterItem = controllers[0]

      scope.widthModifier = utils.readIntAttribute(attrs.widthModifier)
      scope.heightModifier = utils.readIntAttribute(attrs.heightModifier)

      _currentWidth = null
      _currentHeight = null

      _update = ->
        if gridsterItem and gridsterItem.gridster?
          width = gridsterItem.calculateElementWidth()
          height = gridsterItem.calculateElementHeight()
          if width != _currentWidth or height != _currentHeight
            elem.width (width + scope.widthModifier)
            elem.height (height + scope.heightModifier)
            scope.$broadcast "gridsterItemResized", width, height
            _currentWidth = width
            _currentHeight = height

      scope.$on "resizeGridsterItemFigureElement", ->
        _update()

      # we do the initial update in a timeout so that gridster can
      # initialize and we receive accurate data about the size and
      # width of the gridster item
      $timeout ->
        _update()
]
